import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import InputField from "./elements/InputField";
import { ChoiceField } from "./elements/ChoiceField";
import { DateField } from "./elements/DateField";
import { MultiSelect } from "./elements/MultiSelect";
import { SingleSelect } from "./elements/SingleSelect";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import emailjs from "emailjs-com";
import { toJalaali } from "jalaali-js";
import Card from "./elements/Card";
import Popup from "./elements/Popup";

const Form = () => {
  const methods = useForm();
  const navigate = useNavigate();
  const [isEmailSending, setEmailSending] = useState(false);
  const [isFinish, setFinish] = useState(false);
  const [city, setCity] = useState("");
  const [country, setCountry] = useState(0);
  const [center, setCenter] = useState("");
  const [error, setError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const {
    formState: { errors },
  } = methods;

  const countries = [
    { label: "ایران", value: 0 },
    { label: "افغانستان", value: 1 },
    { label: "آلبانی", value: 2 },
    { label: "الجزایر", value: 3 },
    { label: "آندورا", value: 4 },
    { label: "آنگولا", value: 5 },
    { label: "آنتیگوا و باربودا", value: 6 },
    { label: "آرژانتین", value: 7 },
    { label: "ارمنستان", value: 8 },
    { label: "استرالیا", value: 9 },
    { label: "اتریش", value: 10 },
    { label: "آذربایجان", value: 11 },
    { label: "باهاما", value: 12 },
    { label: "بحرین", value: 13 },
    { label: "بنگلادش", value: 14 },
    { label: "باربادوس", value: 15 },
    { label: "بلاروس", value: 16 },
    { label: "بلژیک", value: 17 },
    { label: "بلیز", value: 18 },
    { label: "بنین", value: 19 },
    { label: "بوتان", value: 20 },
    { label: "بولیوی", value: 21 },
    { label: "بوسنی و هرزگوین", value: 22 },
    { label: "بوتسوانا", value: 23 },
    { label: "برزیل", value: 24 },
    { label: "برونئی", value: 25 },
    { label: "بلغارستان", value: 26 },
    { label: "بورکینافاسو", value: 27 },
    { label: "بوروندی", value: 28 },
    { label: "کیپ ورد", value: 29 },
    { label: "کامبوج", value: 30 },
    { label: "کامرون", value: 31 },
    { label: "کانادا", value: 32 },
    { label: "جمهوری آفریقای مرکزی", value: 33 },
    { label: "چاد", value: 34 },
    { label: "شیلی", value: 35 },
    { label: "چین", value: 36 },
    { label: "کلمبیا", value: 37 },
    { label: "کومور", value: 38 },
    { label: "کنگو", value: 39 },
    { label: "جمهوری دموکراتیک کنگو", value: 40 },
    { label: "کاستاریکا", value: 41 },
    { label: "کرواسی", value: 42 },
    { label: "کوبا", value: 43 },
    { label: "قبرس", value: 44 },
    { label: "جمهوری چک", value: 45 },
    { label: "دانمارک", value: 46 },
    { label: "جیبوتی", value: 47 },
    { label: "دومینیکا", value: 48 },
    { label: "جمهوری دومینیکن", value: 49 },
    { label: "تیمور شرقی", value: 50 },
    { label: "اکوادور", value: 51 },
    { label: "مصر", value: 52 },
    { label: "السالوادور", value: 53 },
    { label: "گینه استوایی", value: 54 },
    { label: "اریتره", value: 55 },
    { label: "استونی", value: 56 },
    { label: "اسواتینی", value: 57 },
    { label: "اتیوپی", value: 58 },
    { label: "فیجی", value: 59 },
    { label: "فنلاند", value: 60 },
    { label: "فرانسه", value: 61 },
    { label: "گابن", value: 62 },
    { label: "گامبیا", value: 63 },
    { label: "گرجستان", value: 64 },
    { label: "آلمان", value: 65 },
    { label: "غنا", value: 66 },
    { label: "یونان", value: 67 },
    { label: "گرنادا", value: 68 },
    { label: "گواتمالا", value: 69 },
    { label: "گینه", value: 70 },
    { label: "گینه بیسائو", value: 71 },
    { label: "گویان", value: 72 },
    { label: "هائیتی", value: 73 },
    { label: "هندوراس", value: 74 },
    { label: "مجارستان", value: 75 },
    { label: "ایسلند", value: 76 },
    { label: "هند", value: 77 },
    { label: "اندونزی", value: 78 },
    { label: "عراق", value: 79 },
    { label: "ایرلند", value: 80 },
    { label: "اسرائیل", value: 81 },
    { label: "ایتالیا", value: 82 },
    { label: "جامائیکا", value: 83 },
    { label: "ژاپن", value: 84 },
    { label: "اردن", value: 85 },
    { label: "قزاقستان", value: 86 },
    { label: "کنیا", value: 87 },
    { label: "کیریباتی", value: 88 },
    { label: "کره شمالی", value: 89 },
    { label: "کره جنوبی", value: 90 },
    { label: "کویت", value: 91 },
    { label: "قرقیزستان", value: 92 },
    { label: "لائوس", value: 93 },
    { label: "لتونی", value: 94 },
    { label: "لبنان", value: 95 },
    { label: "لسوتو", value: 96 },
    { label: "لیبریا", value: 97 },
    { label: "لیبی", value: 98 },
    { label: "لیختن اشتاین", value: 99 },
    { label: "لیتوانی", value: 100 },
    { label: "لوکزامبورگ", value: 101 },
    { label: "ماداگاسکار", value: 102 },
    { label: "مالاوی", value: 103 },
    { label: "مالزی", value: 104 },
    { label: "مالدیو", value: 105 },
    { label: "مالی", value: 106 },
    { label: "مالت", value: 107 },
    { label: "جزایر مارشال", value: 108 },
    { label: "موریتانی", value: 109 },
    { label: "موریس", value: 110 },
    { label: "مکزیک", value: 111 },
    { label: "میکرونزی", value: 112 },
    { label: "مولداوی", value: 113 },
    { label: "موناکو", value: 114 },
    { label: "مغولستان", value: 115 },
    { label: "مونته نگرو", value: 116 },
    { label: "مراکش", value: 117 },
    { label: "موزامبیک", value: 118 },
    { label: "میانمار", value: 119 },
    { label: "نامیبیا", value: 120 },
    { label: "نائورو", value: 121 },
    { label: "نپال", value: 122 },
    { label: "هلند", value: 123 },
    { label: "نیوزیلند", value: 124 },
    { label: "نیکاراگوئه", value: 125 },
    { label: "نیجر", value: 126 },
    { label: "نیجریه", value: 127 },
    { label: "مقدونیه شمالی", value: 128 },
    { label: "نروژ", value: 129 },
    { label: "عمان", value: 130 },
    { label: "پاکستان", value: 131 },
    { label: "پالائو", value: 132 },
    { label: "فلسطین", value: 133 },
    { label: "پاناما", value: 134 },
    { label: "پاپوآ گینه نو", value: 135 },
    { label: "پاراگوئه", value: 136 },
    { label: "پرو", value: 137 },
    { label: "فیلیپین", value: 138 },
    { label: "لهستان", value: 139 },
    { label: "پرتغال", value: 140 },
    { label: "قطر", value: 141 },
    { label: "رومانی", value: 142 },
    { label: "روسیه", value: 143 },
    { label: "رواندا", value: 144 },
    { label: "سنت کیتس و نویس", value: 145 },
    { label: "سنت لوسیا", value: 146 },
    { label: "سنت وینسنت و گرنادین", value: 147 },
    { label: "ساموآ", value: 148 },
    { label: "سان مارینو", value: 149 },
    { label: "سائوتومه و پرنسیپ", value: 150 },
    { label: "عربستان سعودی", value: 151 },
    { label: "سنگال", value: 152 },
    { label: "صربستان", value: 153 },
    { label: "سیشل", value: 154 },
    { label: "سیرالئون", value: 155 },
    { label: "سنگاپور", value: 156 },
    { label: "اسلواکی", value: 157 },
    { label: "اسلوونی", value: 158 },
    { label: "جزایر سلیمان", value: 159 },
    { label: "سومالی", value: 160 },
    { label: "آفریقای جنوبی", value: 161 },
    { label: "اسپانیا", value: 162 },
    { label: "سری‌لانکا", value: 163 },
    { label: "سودان", value: 164 },
    { label: "سودان جنوبی", value: 165 },
    { label: "سورینام", value: 166 },
    { label: "سوئد", value: 167 },
    { label: "سوئیس", value: 168 },
    { label: "سوریه", value: 169 },
    { label: "تاجیکستان", value: 170 },
    { label: "تانزانیا", value: 171 },
    { label: "تایلند", value: 172 },
    { label: "توگو", value: 173 },
    { label: "تونگا", value: 174 },
    { label: "ترینیداد و توباگو", value: 175 },
    { label: "تونس", value: 176 },
    { label: "ترکیه", value: 177 },
    { label: "ترکمنستان", value: 178 },
    { label: "تووالو", value: 179 },
    { label: "اوگاندا", value: 180 },
    { label: "اوکراین", value: 181 },
    { label: "امارات متحده عربی", value: 182 },
    { label: "بریتانیا", value: 183 },
    { label: "ایالات متحده آمریکا", value: 184 },
    { label: "اروگوئه", value: 185 },
    { label: "ازبکستان", value: 186 },
    { label: "وانواتو", value: 187 },
    { label: "واتیکان", value: 188 },
    { label: "ونزوئلا", value: 189 },
    { label: "ویتنام", value: 190 },
    { label: "یمن", value: 191 },
    { label: "زامبیا", value: 192 },
    { label: "زیمبابوه", value: 193 },
    { label: "ابخاز", value: 194 },
    { label: "آرتساخ", value: 195 },
    { label: "سومالی‌لند", value: 196 },
    { label: "ماکائو", value: 197 },
    { label: "هنگ کنگ", value: 198 },
    { label: "جمهوری چین", value: 199 },
    { label: "آنگویلا", value: 200 },
    { label: "آروبا", value: 201 },
    { label: "برمودا", value: 202 },
    { label: "بونیر", value: 203 },
    { label: "جزایر ویرجین بریتانیا", value: 204 },
    { label: "جزایر کیمن", value: 205 },
    { label: "کوراسائو", value: 206 },
    { label: "جزیره من", value: 207 },
    { label: "جرزی", value: 208 },
    { label: "مونتسرات", value: 209 },
    { label: "جزایر پیت‌کرن", value: 210 },
    { label: "سنت هلنا", value: 211 },
    { label: "جزایر ترک و کایکوس", value: 212 },
    { label: "جزایر فالکلند", value: 213 },
    { label: "جزایر کک و ککلز", value: 214 },
    { label: "جزایر نورفولک", value: 215 },
    { label: "جزایر آلند", value: 216 },
    { label: "جزیره بووه", value: 217 },
    { label: "جزایر ویرجین ایالات متحده", value: 218 },
    { label: "گوام", value: 219 },
    { label: "پورتوریکو", value: 220 },
    { label: "ساموآی آمریکا", value: 221 },
    { label: "جزایر ماریانای شمالی", value: 222 },
    { label: "میدوی", value: 223 },
    { label: "جزایر بیکر", value: 224 },
    { label: "جزایر جانستون", value: 225 },
    { label: "جزایر جارت", value: 226 },

    { label: "جزایر کینگمن ریف", value: 227 },
    { label: "جزایر پالمیرا", value: 228 },
    { label: "جزایر ویک", value: 229 },
    { label: "جزایر کوک", value: 230 },
    { label: "نیوی", value: 231 },
    { label: "پیت‌کرن", value: 232 },
    { label: "جزایر والیس و فوتونا", value: 233 },
    { label: "جزیره کریسمس", value: 234 },
    { label: "جزایر کوکوس", value: 235 },
    { label: "جزایر پاراکل", value: 236 },
    { label: "جزایر اسپراتلی", value: 237 },
    { label: "جزایر چین جنوبی", value: 238 },
    { label: "جزایر چاگوس", value: 239 },
    { label: "جزایر آشبورگ", value: 240 },
    { label: "ساحل عاج", value: 241 },
    { label: "کابو ورد", value: 242 },
    { label: "جزایر موریس", value: 243 },
    { label: "جزایر سیشل", value: 244 },
    { label: "جزایر کومور", value: 245 },
    { label: "لیبی", value: 246 },
    { label: "مراکش", value: 247 },
    { label: "مصر", value: 248 },
    { label: "الجزایر", value: 249 },
    { label: "بوتان", value: 250 },
    { label: "مولداوی", value: 251 },
  ];

  const convertArray = (data, arr) => {
    let array = [];

    for (const item of data) {
      array.push(arr[item].label);
    }
    return array.join(",");
  };
  const onError = () => {
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };
  const onSubmit = async (data) => {
    setEmailSending(true);
    setError(false);

    data.gender = [
      { label: "انتخاب کنید", value: 0 },
      { label: "مرد", value: 1 },
      { label: "زن", value: 2 },
    ][data.gender].label;
    data.country = countries[data.country].label;
    let date = new Date(data.birthDate.value);
    date = toJalaali(date);

    data.birthDate = `${date.jy}/${String(date.jm).padStart(2, "0")}/${String(
      date.jd
    ).padStart(2, "0")}`;
    if (data.country !== "ایران") {
      data.city = "";
      data.center = "";
    }

    data.selectedAim = convertArray(data.selectedAim, [
      { label: "می‌خواهم عمر طولانی داشته باشم.", value: 0 },
      { label: "می‌خواهم سالم زندگی کنم.", value: 1 },
      {
        label: "می‌خواهم کیفیت زندگی‌‌ام را بهبود ببخشیم.",
        value: 2,
      },
    ]);
    if (data.selectedDisease) {
      data.selectedDisease = convertArray(data.selectedDisease, [
        { label: "ُپرفشاری خون", value: 0 },
        { label: "دیابت", value: 1 },
        { label: "بیماری قلبی", value: 2 },
        { label: "بیماری کلیوی", value: 3 },
        { label: "آسم یا دیگر بیماری‌های تنفسی", value: 4 },
      ]);
    } else {
      data.selectedDisease = "";
    }
    if (data.other) {
      data["otherDisease"] = data.other;
    } else {
      data.other = "";
    }

    data.changeLife = convertArray(data.changeLife, [
      { label: "بله", value: 0 },
      { label: "خیر", value: 1 },
      { label: "شاید", value: 2 },
    ]);
    data.food = convertArray(data.food, [
      { label: "بله", value: 0 },
      { label: "خیر", value: 1 },
      { label: "شاید", value: 2 },
    ]);
    data.walking = convertArray(data.walking, [
      { label: "کمتر از یک ساعت", value: 0 },
      { label: "بین ۱ الی ۳ ساعت", value: 1 },
      { label: "بالای ۳ ساعت", value: 2 },
    ]);
    data.stress = convertArray(data.stress, [
      { label: "کم", value: 0 },
      { label: "متوسط", value: 1 },
      { label: "زیاد", value: 2 },
    ]);
    data.sleep = convertArray(data.sleep, [
      { label: "ضعیف", value: 0 },
      { label: "متوسط", value: 1 },
      { label: "خوب", value: 2 },
    ]);
    data.eatingM = convertArray(data.eatingM, [
      { label: "۵ تا ۱۰ میلیون ", value: 0 },
      { label: "۱۰ تا ۲۰ میلیون", value: 1 },
      { label: "بالای ۲۰ میلیون", value: 2 },
    ]);
    data.drug = convertArray(data.drug, [
      { label: "۵ تا ۱۰ میلیون ", value: 0 },
      { label: "۱۰ تا ۲۰ میلیون", value: 1 },
      { label: "بالای ۲۰ میلیون", value: 2 },
    ]);
    data.testing = convertArray(data.testing, [
      { label: "۵ تا ۱۰ میلیون ", value: 0 },
      { label: "۱۰ تا ۲۰ میلیون", value: 1 },
      { label: "بالای ۲۰ میلیون", value: 2 },
    ]);
    console.log(data);
    try {
      await emailjs.send(
        "service_29v5u8h",
        "template_ygjg78a",
        data,
        "8rjrcUKtlnVKcPtOO"
      );

      setFinish(true);
    } catch (error) {
      setError(true);
      setFinish(true);
    }
    setEmailSending(false);
  };

  const handleCenterChange = (e) => {
    if (country != 0) setCenter("");
    else setCenter(e.target.value);
  };
  const handleCityChange = (e) => {
    if (country != 0) setCenter("");
    else setCity(e.target.value);
  };
  const centeredRef = useRef(null);

  const handleClickOutside = (event) => {
    if (centeredRef.current && !centeredRef.current.contains(event.target)) {
      setFinish(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <Popup
        message="لطفا خطاهای موجود در فرم را برطرف کنید."
        show={showPopup}
        onClose={() => setShowPopup(false)}
      />

      {(isFinish || error) && (
        <Card
          ref={centeredRef}
          setFinish={setFinish}
          error={error}
          setError={setError}
        />
      )}
      {(isFinish || error) && (
        <div
          onClick={() => {
            setFinish(false);
          }}
          class="fixed z-20 bg-white backdrop-blur-sm bg-opacity-30  w-full h-full inset-0"
        ></div>
      )}

      <Header />
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit, onError)}
          className=" max-w-5xl mx-auto p-4 pb-4 bg-white mt-4"
        >
          <div className="relative  rounded-xl border-2 bg-white border-white p-4 ">
            <h1 className=" text-right px-6 text-xl mb-12 font-semibold">
              فرم ارزیابی
            </h1>
            <div className=" px-6 pt-6 pb-1 rounded-xl border-dashed border-2 relative  my-8 border-gray-400">
              <h2 className="absolute right-2 -top-4 px-4 bg-white text-gray-500 text-md ">
                اطلاعات پایه
              </h2>
              <InputField
                rules={{ required: "لطفا این فیلد را تکمیل نمایید." }}
                type="text"
                label="نام"
                name="firstName"
              />

              <InputField
                rules={{ required: "لطفا این فیلد را تکمیل نمایید." }}
                type="text"
                label="نام خانوادگی"
                name="lastName"
              />
              <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمایید.",
                  pattern: {
                    value: /^[+-]?\d+$/,
                    message: "لطفا شماره تماس معتبر وارد کنید.",
                  },
                }}
                type="text"
                label="شماره تماس"
                name="mobile"
                convertToLatin={true}
              />
              <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمایید.",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "ایمیل معتبر نیست",
                  },
                }}
                type="email"
                label="ایمیل"
                name="email"
              />

              <ChoiceField
                rules={{ required: "لطفا این فیلد را تکمیل نمایید." }}
                label="جنسیت"
                options={[
                  { label: "انتخاب کنید", value: 0 },
                  { label: "مرد", value: 1 },
                  { label: "زن", value: 2 },
                ]}
                name="gender"
              />

              <DateField
                label="تاریخ تولد"
                name="birthDate"
                rules={{ required: "لطفا این فیلد را تکمیل نمایید." }}
              />
              <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمایید.",
                  pattern: {
                    value: /^[+-]?(\d+(\.\d{0,2})?)$/,
                    message: "لطفا عدد معتبر تا دو رقم اعشار وارد نمایید.",
                  },
                }}
                type="text"
                step={0.5}
                label="قد (سانتی‌متر)"
                name="height"
                convertToLatin={true}
              />
              <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمایید.",
                  pattern: {
                    value: /^[+-]?(\d+(\.\d{0,1})?)$/,
                    message: "لطفا عدد معتبر تا یک رقم اعشار وارد کنید.",
                  },
                }}
                type="text"
                label="وزن (کیلوگرم)"
                name="width"
                convertToLatin={true}
              />
              <ChoiceField
                rules={{ required: "لطفا این فیلد را تکمیل نمایید." }}
                label="کشور"
                options={countries}
                name="country"
                onChange={setCountry}
              />
              {/*   <InputField
                rules={{
                  required: "لطفا این فیلد را تکمیل نمایید.",
                }}
                value={country}
                type="text"
                label="کشور"
                name="country"
                onChange={handleCountryChange}
                hasOnChange={true}
              /> */}
              {country == 0 && (
                <>
                  <InputField
                    rules={{ required: "لطفا این فیلد را تکمیل نمایید." }}
                    type="text"
                    label="استان"
                    name="center"
                    value={center}
                    onChange={handleCenterChange}
                    hasOnChange={true}
                  />
                  <InputField
                    rules={{ required: "لطفا این فیلد را تکمیل نمایید." }}
                    type="text"
                    label="شهر"
                    name="city"
                    value={city}
                    onChange={handleCityChange}
                    hasOnChange={true}
                  />
                </>
              )}
            </div>
            <div className="mt-8 mb-6 p-6 pb-1 rounded-xl border-dashed border-2 relative border-gray-400">
              <h2 className="absolute right-2 -top-4 px-4 bg-white text-gray-500">
                اطلاعات تکمیلی
              </h2>
              <MultiSelect
                label="از شرکت در برنامه لانجویتی چه انتظاری دارید؟"
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                options={[
                  { label: "می‌خواهم عمر طولانی داشته باشم.", value: 0 },
                  { label: "می‌خواهم سالم زندگی کنم.", value: 1 },
                  {
                    label: "می‌خواهم کیفیت زندگی‌‌ام را بهبود ببخشیم.",
                    value: 2,
                  },
                ]}
                name="selectedAim"
              />
              <MultiSelect
                label="در حال حاضر مبتلا به کدام بیماری هستید؟"
                options={[
                  { label: "ُپرفشاری خون", value: 0 },
                  { label: "دیابت", value: 1 },
                  { label: "بیماری قلبی", value: 2 },
                  { label: "بیماری کلیوی", value: 3 },
                  { label: "آسم یا دیگر بیماری‌های تنفسی", value: 4 },
                ]}
                name="selectedDisease"
                textarea={true}
              />
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="آیا حاضر به اِعمال تغییرات اساسی در سبک زندگی فعلی‌تان هستید؟"
                options={[
                  { label: "بله", value: 0 },
                  { label: "خیر", value: 1 },
                  { label: "شاید", value: 2 },
                ]}
                name="changeLife"
              />
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="آیا به نظر خودتان در حال حاضر از تغذیه سالمی پیروی می‌کنید؟"
                options={[
                  { label: "بله", value: 0 },
                  { label: "خیر", value: 1 },
                  { label: "شاید", value: 2 },
                ]}
                name="food"
              />
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="در حال حاضر در هفته چند ساعت ورزش می‌کنید؟ (پیاده‌روی را حساب نکنید)"
                options={[
                  { label: "کمتر از یک ساعت", value: 0 },
                  { label: "بین ۱ الی ۳ ساعت", value: 1 },
                  { label: "بالای ۳ ساعت", value: 2 },
                ]}
                name="walking"
              />
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="میزان استرس شما طی یک ماه گذشته چقدر بوده؟"
                options={[
                  { label: "کم", value: 0 },
                  { label: "متوسط", value: 1 },
                  { label: "زیاد", value: 2 },
                ]}
                name="stress"
              />{" "}
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="کیفیت خواب خود را چگونه ارزیابی می‌کنید؟"
                options={[
                  { label: "ضعیف", value: 0 },
                  { label: "متوسط", value: 1 },
                  { label: "خوب", value: 2 },
                ]}
                name="sleep"
              />{" "}
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="تا چه مقدار حاضر به صرف هزینه برای تغذیه‌ی سالم در ماه هستید؟"
                options={[
                  { label: "۵ تا ۱۰ میلیون ", value: 0 },
                  { label: "۱۰ تا ۲۰ میلیون", value: 1 },
                  { label: "بالای ۲۰ میلیون", value: 2 },
                ]}
                name="eatingM"
              />
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="تا چه مقدار حاضر به صرف هزینه برای انجام تست‌های پاراکلینیک، ورزش و… هستید؟"
                options={[
                  { label: "۵ تا ۱۰ میلیون ", value: 0 },
                  { label: "۱۰ تا ۲۰ میلیون", value: 1 },
                  { label: "بالای ۲۰ میلیون", value: 2 },
                ]}
                name="testing"
              />
              <SingleSelect
                rules={{ required: "لطفا یک گزینه انتخاب کنید." }}
                label="تا چه مقدار حاضر به صرف هزینه برای تهیه دارو و مکمل‌ هستید؟"
                options={[
                  { label: "۵ تا ۱۰ میلیون ", value: 0 },
                  { label: "۱۰ تا ۲۰ میلیون", value: 1 },
                  { label: "بالای ۲۰ میلیون", value: 2 },
                ]}
                name="drug"
              />
            </div>
            <div className="flex justify-between w-full">
              <button
                className={`  
         text-lg border-buttonGray border-2  text-gray-800   px-6  py-2  w-32 rounded-lg flex items-center  cursor-pointer   font-bold  transition-all duration-200   z-10 hover:bg-buttonGray ${
           isEmailSending && "opacity-50 cursor-progress border-buttonGray"
         }`}
                type="button"
                disabled={isEmailSending ? true : false}
              >
                <span
                  className=" mx-auto text-gray-500"
                  onClick={() => navigate("/")}
                >
                  بازگشت
                </span>
              </button>
              <button
                className={` border-bgBlue border-2 
         text-lg hover:bg-bgHoverBlue   text-white px-6  py-2  w-32 rounded-lg flex items-center  cursor-pointer   font-bold  transition-all duration-200  bg-bgBlue ${
           isEmailSending && "bg-bgHoverBlue cursor-progress opacity-50"
         } `}
                type="submit"
                disabled={isEmailSending ? true : false}
              >
                {isEmailSending ? (
                  <div className="flex items-center justify-center mx-auto">
                    <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white-500"></div>
                  </div>
                ) : (
                  <span className=" mx-auto">ثبت</span>
                )}
              </button>
            </div>
          </div>
        </form>
      </FormProvider>
      <Footer />
    </>
  );
};

export default Form;
